<template>
  <div class="wrapper">
    <div class="wrapper-body" v-if="all_blogs.length > 0">
      <div class="left-panel">
        <div class="left-panel-header">
          <h3>BLOGS</h3>
          <b-button type="is-primary" outlined @click="addBlog()">ADD BLOG</b-button>
        </div>
        <div class="left-panel-body">
          <div v-if="all_blogs.length > 0 && !loading_blogs">
            <div class="blog_crd" :class="{ 'active': selected_blog && selected_blog.id == blog.id }"
              v-for="(blog, index) in all_blogs" :key="index" @click="showBlogData(blog)">
              <div class="blog_crd_img_cover">
                <video v-if="$GetExt(blog.image) == 'mp4'" :src="$store.state.ASSETS_BASE_URL +
                  '/assets/uploaded/' +
                  blog.image
                  " controls></video>
                <img v-else :src="$store.state.ASSETS_BASE_URL +
                  '/assets/uploaded/' +
                  blog.image
                  " />

                <div class="crd_options">
                  <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                    <template #trigger>
                      <b-icon icon="dots-vertical" type="is-white"></b-icon>
                    </template>

                    <b-dropdown-item @click="viewBlog(blog)" aria-role="listitem">
                      View</b-dropdown-item>
                    <b-dropdown-item @click="updateBlog(blog)" aria-role="listitem">
                      Update</b-dropdown-item>
                    <b-dropdown-item @click="deleteBlog(blog)" aria-role="listitem">
                      Delete</b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
              <h1>{{ blog.title }}</h1>
              <p v-html="blog.content"></p>
              <span class="visibility" :class="{ 'unlisted': blog.status == 'unlisted' }">{{ blog.status }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selected_blog" class="right-panel" :class="{ active_session: selected_blog != null }">
        <div class="right-panel-header">
          <h3>COMMENTS</h3>
          <div class="right-panel-header-right-side">
            <b-button v-if="blogComments.length > 0" type="is-primary" @click="deleteAllComments(selected_blog.id)">DELETE
              ALL COMMENTS</b-button>
            <div class="h-spacer"></div>
            <b-button type="is-default" outlined @click="selected_blog = null, blogComments = []">Close</b-button>
          </div>

        </div>
        <div class="right-panel-body" v-if="blogComments.length > 0">
          <div class="comment_card" v-for="(comment, index) in blogComments" :key="index">
            <div class="comment_card_logo">
              <img :src="$store.state.ASSETS_BASE_URL +
                '/assets/uploaded/' +
                comment.profile_image
                " />
            </div>
            <div class="comment_card_data">
              <div class="comment_card_data_names">
                <h1>@{{ comment.first_name }} {{ comment.last_name }} <span>{{ comment.created_at }}</span></h1>
                <div class="comment_options">
                  <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                    <template #trigger>
                      <b-icon icon="dots-vertical"></b-icon>
                    </template>
                    <b-dropdown-item @click="deleteComment(comment)" aria-role="listitem">
                      Delete</b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
              <p>{{ comment.content }}</p>
            </div>
          </div>
        </div>
        <div v-else class="right-panel-body">
          <widgetNotfound title="No Comments Found" subtitle="This blog has no comments."></widgetNotfound>
        </div>
      </div>
      <div v-else class="right-panel">
        <widgetNotfound title="No Blog Selected" subtitle="Select a blog to view comments."></widgetNotfound>
      </div>
    </div>
    <div class="wrapper-body" v-else>
      <div class="notFound-wrapper">
        <widgetNotfound title="No Blog Available" subtitle="Use button below to add new blog" btn="Add Blog"
          @click="addBlog()">
        </widgetNotfound>
      </div>
    </div>

    <addBlogModal v-if="show_modal" @close="show_modal = false" :value="selected_blog_modal" @success="onAddBlog()">
    </addBlogModal>
    <BlogView v-if="view_blog" :value="selected_blog_modal" @close="closeView"></BlogView>
  </div>
</template>

<script>
import addBlogModal from './modals/blogs/add_blog_modal.vue';
import BlogView from './modals/blogs/view_blog_modal.vue';
export default {
  components: { addBlogModal, BlogView },
  data() {
    return {
      selected_blog: null,
      all_blogs: [],
      loading_blogs: false,
      selected_blog_modal: null,
      show_modal: false,
      view_blog: false,
      blogComments: []
    }
  },
  mounted() {
    let vm = this;
    vm.getAllBlogs();
  },
  methods: {
    showBlogData(item) {
      let vm = this;
      vm.selected_blog = item;
      vm.$store
        .dispatch('BLOGS_GET_COMMENTS', { id: item.id })
        .then(resp => vm.blogComments = resp.data.return)
        .catch(err => console.log(err))
    },
    addBlog() {
      let vm = this;
      vm.selected_blog_modal = null
      vm.show_modal = true;
    },
    viewBlog(item) {
      let vm = this;
      vm.selected_blog_modal = item;
      vm.view_blog = true;
    },
    onAddBlog() {
      let vm = this;
      vm.show_modal = false;
      vm.getAllBlogs();
    },
    closeView() {
      let vm = this;
      vm.view_blog = false;
    },
    updateBlog(item) {
      let vm = this;
      vm.selected_blog_modal = item
      vm.show_modal = true;
    },
    deleteBlog(item) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Deleting Blog",
        message:
          "Are you sure you want to <b>delete</b> this blog? This action cannot be undone.",
        confirmText: "Delete Blog",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          console.log({ id: item.id })
          vm.$store
            .dispatch("BLOGS_DELETE", {
              id: item.id,
            })
            .then((response) => {
              vm.selected_event_session = null;
              vm.getAllBlogs();

              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: "Something went wrong, Contact your administrator",
              });
            });
        }
      })

    },
    deleteComment(item) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Deleting Comment",
        message:
          "Are you sure you want to <b>delete</b> this comment? This action cannot be undone.",
        confirmText: "Delete Comment",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("BLOG_DELETE_COMMENT", {
              id: item.id,
            })
            .then((response) => {
              vm.selected_event_session = null;
              vm.showBlogData(item.blogId)

              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: "Something went wrong, Contact your administrator",
              });
            });
        }
      })

    },
    deleteAllComments(item) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Deleting All Comments",
        message:
          "Are you sure you want to <b>delete</b> all comments? This action cannot be undone.",
        confirmText: "Delete All Comments",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("BLOG_DELETE_COMMENTS", {
              id: item,
            })
            .then((response) => {
              vm.selected_event_session = null;
              vm.showBlogData(item)

              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: "Something went wrong, Contact your administrator",
              });
            });
        }
      })

    },
    getAllBlogs() {
      let vm = this;
      console.log('FN RUN');
      vm.$store
        .dispatch('BLOGS_GET_ALL')
        .then(response => vm.all_blogs = response.data.return)
        .catch(err => console.log(err))
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: hidden;

  .wrapper-body {
    height: 100%;
    display: flex;
    flex-direction: row;

    .notFound-wrapper {
      display: flex;
      justify-content: center;
      width: 100%;
      height: 100%;
      align-items: center;
    }


    .left-panel {
      width: 400px;
      height: 100%;
      border-right: 1px solid #ddd;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      .left-panel-header {
        border-bottom: 1px solid #ddd;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        padding: 0px 10px;

        h3 {
          font-size: 14px;
          font-weight: 600;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }

      .left-panel-body {
        height: calc(100% - 60px);
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 10px;
          background: #efefef;
        }

        &::-webkit-scrollbar-thumb {
          background: var(--wecodefy-secondary-color, #9fc953);
        }

        .blog_crd {
          padding: 15px;
          cursor: pointer;
          transition: .5s;

          &.active {
            background: #EBF3DD;
          }

          &:hover {
            &:not(.active) {
              background: #dbdbdb;
            }
          }

          &:not(:last-of-type) {
            border-bottom: 1px solid #ddd;
          }

          .blog_crd_img_cover {
            width: 100%;
            height: 250px;
            position: relative;
            z-index: 1;
            border-radius: 8px;
            overflow: hidden;

            &::before {
              content: '';
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              background: linear-gradient(to bottom, rgba(0, 0, 0, 0.504), transparent);
            }

            img,
            video {
              width: 100%;
              height: 100%;
              object-fit: cover;
              object-position: top;
            }

            .crd_options {
              position: absolute;
              top: 10px;
              right: 10px;
              z-index: 1;
              cursor: pointer;
            }
          }

          h1 {
            margin: 12px 0 10px;
            text-transform: uppercase;
          }

          p {
            color: grey;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            margin-bottom: 10px;
          }

          span.visibility {
            display: flex;
            width: fit-content;
            padding: 6px 17px;
            font-size: 14px;
            border-radius: 5px;
            background: #48C78E;
            color: white;
            text-transform: uppercase;

            &.unlisted {
              background: #F14668;
            }
          }
        }
      }
    }

    .right-panel {
      width: calc(100% - 400px);
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      @media (max-width: 830px) {
        position: absolute;
        background: white;
        z-index: 10;
        top: 0px;
        right: -800px;
        width: 85%;
        box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);
        transition: .5s;
      }

      &.active_session {
        @media (max-width: 830px) {
          right: 0;
        }
      }

      .right-panel-header {
        border-bottom: 1px solid #ddd;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        padding: 0px 10px;

        h3 {
          font-size: 14px;
          font-weight: 600;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          @media (max-width: 830px) {
            display: none;
          }
        }

        .right-panel-header-right-side {
          display: flex;
          align-items: center;
        }
      }

      .right-panel-body {
        height: calc(100% - 60px);
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 10px;
          background: #efefef;
        }

        &::-webkit-scrollbar-thumb {
          background: var(--wecodefy-secondary-color, #9fc953);
        }

        button {
          display: flex;
          margin: 20px auto 30px;
        }

        .comment_card {
          padding: 10px 20px;
          display: flex;
          column-gap: 15px;
          transition: .5s;

          &:not(:last-of-type) {
            border-bottom: 1px solid #ddd;
          }

          &:hover {
            background: #dbdbdb83;
          }

          .comment_card_logo {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            overflow: hidden;
            flex-shrink: 0;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .comment_card_data {
            width: 100%;

            .comment_card_data_names {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 7px;

              .comment_options {
                cursor: pointer;
              }

              h1 {
                display: flex;
                align-items: center;
                font-size: 16px;

                span {
                  margin-left: 5px;
                  font-size: 14px;
                  color: grey;
                }

                @media (max-width: 1207px) {
                  flex-direction: column;

                  span {
                    margin-left: 0px !important;
                    font-size: 13px;
                  }
                }

              }
            }

            p {
              opacity: .8;
            }
          }
        }
      }
    }
  }
}
</style>
